import Cookies from "js-cookie";
import axios from "axios";
import { urls } from "@/public/utils/env";
import appConfig from "@/public/globalConfig";
import RefreshToken from "./refreshToken";

//验证cookie是否有效 validate():promise
export var refreshToken = new RefreshToken({});
export function validate() {
    return refreshToken.valid();
    return new Promise((resolve, reject) => {
        let userInfo = Cookies.getJSON("EDCurrent");
        if (userInfo) {
            let id = userInfo.user_id,
                token = userInfo.token,
                refresh_token = userInfo.refresh_token;
            axios
                .get(`${urls.userUrl}/api/user/user/valid?token=${refresh_token}`, {
                    headers: {
                        Authorization: "Bearer " + refresh_token,
                        "X-User-Id": id,
                    },
                })
                .then(() => {
                    //cookie is valid
                    resolve(userInfo);
                })
                .catch(() => {
                    Cookies.remove("EDCurrent");
                    reject();
                });
        } else {
            reject();
        }
    });
}

export function logout() {
    let userInfo = Cookies.getJSON("EDCurrent");
    if (!userInfo) return;
    Cookies.remove("EDCurrent");
    const { token, user_id, refresh_token } = userInfo;
    axios
        .post(
            `${urls.userUrl}/api/user/user/logout`,
            {},
            {
                headers: {
                    Authorization: "Bearer " + refresh_token,
                    "X-User-Id": user_id,
                },
            }
        )
        .finally(() => {
            location.href = `${location.origin}${appConfig.sourcePath}auth/auth.html`;
        });
}
export function setCookie(userInfo) {
    if (!userInfo?.token) {
        return;
    }

    let exp = userInfo.token.split(".")[1];
    exp = JSON.parse(window.atob(exp)).exp;
    const config = {
        expires: new Date(Number(exp) * 1000),
    };
    if (location.protocol === "https:") {
        Object.assign(config, {
            sameSite: "None",
            secure: true,
        });
    }
    // 设置cookie
    Cookies.set("EDCurrent", JSON.stringify(userInfo), config);
}
